// Simple neon border injection for Shopify Dawn
document.addEventListener('DOMContentLoaded', function() {
  // Wait a bit to ensure page is fully loaded
  setTimeout(function() {
    const border = document.createElement('div');
    border.className = 'neon-border-overlay';
    
    // Add to page
    document.body.appendChild(border);
    
    console.log('Neon border added successfully');
  }, 500);
});